import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BaasMenuButton } from '../../../baas-menu-button/baas-menu-button';
import { BaasMenuButtonItemOptions } from '../../../baas-menu-button/baas-menu-button-item.types';

@Component({
    selector: 'baas-meer-acties',
    templateUrl: './baas-meer-acties.component.html',
    imports: [BaasMenuButton],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaasMeerActiesComponent {
    readonly items = input.required<BaasMenuButtonItemOptions[]>();
}
